import styled from "styled-components";

const GAP_BETWEEN_TEXT_AND_ICON = "3px";

export const RowDisplayText = styled.div(({ theme }) => ({
    "& > div": {
        display: "flex",
        alignItems: "center",
        "& > img": {
            height: theme.spacing.medium,
            width: theme.spacing.medium,
            marginLeft: GAP_BETWEEN_TEXT_AND_ICON,
        },
    },
}));
